<template>

    <div id="chat-list" class="chat-list widget">

        <div class="panel">
            <div class="panel-heading"><span class="badge" v-if="unread && unread > 0">{{unread}}</span>
                <h2>Chat <i class="clippie fa fa-info-circle" v-tooltip="'Realtime instant messaging'"></i></h2>
                <div class="toggle-widget" @click="open=!open, getGroups()">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open===true" v-if="users">


                <input v-model="searchTerm" debounce="500" class="form-control search" placeholder="Search Users">
             
                <VuePerfectScrollbar class="scroll-area" >

                    <ul class="chat-users">
                        <li 
                        @click.prevent="openChatSession(user, index); selectForGroup(user)" 
                        class="user"
                        v-bind:class="{'selected': counterParts === user.id, 'selected-for-group': isInGroup(user.id)}"
                        v-for="(user, index) in users">

                        <i v-if="user.online===true" class="fa fa-circle online"></i>
                        <i v-else class="fa fa-circle offline"></i>
                        {{user.firstName}} {{user.lastName}}
                        <img :src="user.roles | roleIcon" class="role-icon">
                        <i v-if="user.conversationId && $store.getters.unreadChatMessages.indexOf(user.conversationId) > -1" class="fa fa-comments bounce"></i>
                        </li>
                    </ul>
                </VuePerfectScrollbar>
                    <div v-for="(chatSession, index) in chatSessions" v-if="chatSessions.length > 0">
                        <div>
                            <chat-messages         
                            :isGroupMessage="chatSession.isGroupMessage"  
                            :chatName="chatSession.chatName" 
                            :counterParts="chatSession.counterParts" 
                            :group="chatSession.selectedGroup"
                            :id="chatSession.id"
                            :position="index">            
                            </chat-messages>
                        </div>
                    </div>


            </div>
                <form @submit.prevent="createGroup" v-show="showGroupForm">
                    <div class="form-group">
                        <label>Select users above to create a group:</label>
                        <input type="text" v-model="groupName" class="form-control" placeholder="Group Name">
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-default create">Create Group</button>
                        <button @click.prevent="showGroupForm=false; groupMembers=[]" class="btn btn-default">Cancel</button>
                    </div>

                </form>

        </div>
        <div class="groups" v-show="open===true">
            <h4 class="text-center">Chat Groups</h4>
            <ul v-if="groups">
            <li v-for="(group, index) in groups" @click="openGroupSession(group)" class="group">
                {{group.name}}
                <i v-if="group.createdBy == localStorage.user_id" class="fa fa-ban" @click="deleteGroup($event, group._id, index)"></i>
            </li>    
            </ul>
            <button @click.prevent="showGroupForm = !showGroupForm; closeChat()" class="create-group"><i class="fa fa-plus"></i></button>

        </div>
    </div>

</template>

<script>
    
    import chat from '../../services/chat';

    import chatMessages from './ChatMessages.vue';
    import {mapGetters} from 'vuex';

    import toastr from 'toastr';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        data() {
            return {
                open: false,
                showChat: false,
                counterParts: null,
                chatName: null,
                searchTerm: null,
                groupName: null,
                groupMembers: [],
                showGroupForm: false,
                groups: null,
                selectedGroup:null,
                isGroupMessage: false,
            }
        },
        components: {
            'chat-messages': chatMessages,
            VuePerfectScrollbar
        },
        mounted() {
            this.getGroups();
           
        },
        methods: {
            getConversations() {                   
                var self = this;
                var thisUser = parseInt(localStorage.user_id);
                chat.getConversations(this).then(function(response) {
                    var conversations = response.data;

                    conversations.forEach(function(conversation) {

                        let j = conversation.participants.indexOf(localStorage.user_id);

                        conversation.participants.splice(j, 1);
                        var otherId = conversation.participants[0];

                        let index = self.users.findIndex(function(u) { return u.id == otherId});

                        if (index > -1) {
                           self.users[index].conversationId = conversation.id;   
                           let unread = conversation.hasUnreadFor.indexOf(thisUser);
                            
                            if (unread > -1) {   
                                self.$store.dispatch('push', {type: 'unreadChatMessages', data: conversation.id});
                            }

                        }
                    });
                });
            },
            openChatSession(user, index) {
                if (this.showGroupForm === true) return;
                var self = this;
                var counterParts = [user.id];
                chat.getConversation(this, counterParts, 1, null).then(function(response) {  
                    chat.markAsRead(self, {id: response.data.id});

                    var chatSession = {
                        counterParts: user.id,
                        isGroupMessage: false,
                        chatName: user.firstName + ' ' + user.lastName,
                        id: response.data.id,
                        messages: response.data.messages || []
                    }

                    var data = {
                        type: 'chatSessions',
                        data: chatSession
                    }

                    self.$store.dispatch('addChatSession', data);
                    self.$store.dispatch('splice', {type: 'unreadChatMessages', data: user.conversationId});
                });
 
            },
            openGroupSession(group) {
                var self = this;
                 this.isGroupMessage = true;
              
                chat.getGroupMessages(this, localStorage.uuid, group._id).then(function(response) {
                   var chatSession = {
                        isGroupMessage: true,
                        chatName: group.name,
                        counterParts: group.counterparts,
                        id: group._id,
                        messages: response.data.messages || []
                    }

                    var data = {
                        type: 'chatSessions',
                        data: chatSession
                    }
                    self.$store.dispatch('addChatSession', data);

                // var messages = {
                //     type: 'chatMessages'                   
                // }

                // if (response.data.messages) messages['data'] = response.data.messages;
                // else messages['data'] = [];
                // self.$store.dispatch('populate', messages);

             })
                
            },
            selectForGroup(user) {
                if (this.showGroupForm === false) return;
                let index = this.groupMembers.findIndex(function(u){ return u.id === user.id});
                if (index === -1) this.groupMembers.push({
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName,
                    roles: user.roles
                });
                else (this.groupMembers.splice(index, 1));
            },
            createGroup() {
                var self = this;
                if (!this.groupName) { toastr.error('Please add a name for the group'); return; }
                if (this.groupMembers.length < 1) { toastr.error('Please add at least one person to the group'); return; }
               
                chat.createGroup(this, this.groupName, localStorage.uuid, this.groupMembers).then(function(response) {
                    self.showGroupForm = false;
                    self.groupMembers = [];
                    self.getGroups();
                });

            },
            deleteGroup(event, groupId, index) {
                event.stopPropagation();
                var self = this;
                chat.deleteGroup(this, groupId).then(function(response) {
                    self.groups.splice(index, 1);
                });

            },
            isInGroup(id) {
                let index = this.groupMembers.findIndex(function(u) { return u.id === id});
                return index > -1;
            },
            getGroups() {
                var self = this;
                chat.getGroups(this, localStorage.uuid).then(function(response) {
                
                    self.groups = response.data;
                });
            },

            closeChat(index) {
                this.chatSessions.splice(index, 1);
                this.$store.dispatch('reset', 'chatMessages');

            },

        },

        computed: {   
            unreadMessagesFromUser(id) {
                return this.$store.getters.unreadChatMessages.indexOf(id) > -1;
            },

            unread() {
                return this.$store.getters.unreadChatMessages.length;
            },
            chatSessions() {
                return this.$store.state.chatSessions;
            },
            users() {
                var self = this;
                var users = this.$store.getters.chatUsers;
                if (users) {
                     this.getConversations();
                }
                if (this.searchTerm) {
                    users = users.filter(function(u) {
                        let name = (u.firstName + ' ' + u.lastName).toLowerCase();
                        return name.indexOf(self.searchTerm.toLowerCase()) > -1;
                    });
                }

                return users;
            }
        }
    }
</script>


<style lang="scss" scoped>
.chat-list {
    position:relative;
    z-index:9999999;
}
.chat-users {
    margin:0;
    padding:0;
    position:relative;
    height:300px;
}
li {
    list-style-type:none;
    padding: 1rem;
    &.selected {
      background:transparentize(#42b983, .5);
      color:#fff; 
    }
    &.selected-for-group {
        background: #4b8da5;
        color:#fff;
    }
}
.fa-circle {
    position: relative;
    left:-0.5rem;
}
.fa-ban {
    float:right;
    margin-right:2rem;
}
.panel-body {
    padding:0;

}
.online {
    color: #359368;
}

.offline {
    color:#a5242a;
}
.groups {
    width:250px;
    background:#303133;
    margin:0 auto;
    margin-top:-30px;
    box-shadow: inset 0px 10px 10px 0px rgba(0,0,0,0.25);

    h4 {font-weight:100;}

}

.form-group {
    label {
        margin-top:15px;
        color: white;
        //text-align:center;
        display: block;
    }
}

.group {
    .fa-ban {
        color:red;
        cursor:pointer;
    }
}
.user, .group {
    cursor: pointer;
}
.search.form-control {
    float: none;
    display: block;
    max-width: 90%;
    //background: transparent!important;
    border-bottom: 1px solid #999!important;
    margin: 10px auto;
    padding: 5px;
    //box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.25);
    background-color:rgba(0,0,0,.2)!important;
}
h4 {
    padding:1rem;
    border-bottom: 1px solid #7e7f80!important;
    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.25);
}
h5 {
    padding:0 1rem;
    
    text-align: center;
}
.list-group .list-group-item {
    border:none;
    border-radius: 0;
    border-top: 1px solid;
    border-bottom: 1px solid;
}
.create-group {
    display: inline-block;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    font-size: 15px;
    line-height: 1.42857;
    user-select: none;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    padding: 10px 15px;
    float:right;
    margin-top:-3rem;
    margin-right:-2rem;
    border-radius: 50%;
    color: #fff;
    background-color: #464545;
    border-color: #464545;
}
.create {
    margin:1rem;
}
label {
    padding-left:.5rem;
}

@keyframes bounce {
  from, 20%, 53%, 80%, to {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transform: translate3d(0,0,0);
  }

  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translate3d(0, -10px, 0);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translate3d(0, -4px, 0);
  }

  90% {
    transform: translate3d(0, -1px, 0);
  }
}

.bounce {
    animation-name: bounce;
    transform-origin: center bottom;
    animation-duration: 1.1s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
}

</style>


// WEBPACK FOOTER //
// ChatList.vue?19ea6460